export const internalPasswordLoginRestricted = (username?: string): boolean => {
    return !username || !username.trim() || username.trim().endsWith('@tripleten.com');
};
